import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
export const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [particles, setParticles] = useState([]);
  useEffect(() => {
    setIsVisible(true);
    // Generate random particles
    const newParticles = Array.from({
      length: 70
    }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 10 + 3,
      duration: Math.random() * 20 + 10,
      delay: Math.random() * 5,
      opacity: Math.random() * 0.5 + 0.2,
      pulse: Math.random() > 0.5
    }));
    setParticles(newParticles);
  }, []);
  return <section id="home" className="relative w-full h-screen bg-black overflow-hidden" data-id="element-163">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0 z-0" data-id="element-164">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black z-10" data-id="element-165"></div>
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1566840570916-9a35a4a8b91d?q=80&w=1470&auto=format&fit=crop')] bg-cover bg-center opacity-30" style={{
        backgroundPosition: 'center 30%'
      }} data-id="element-166"></div>
      </div>
      {/* Animated particles with enhanced effects */}
      <div className="absolute inset-0 z-5 overflow-hidden" data-id="element-167">
        {particles.map(particle => <div key={particle.id} className={`absolute rounded-full bg-blue-primary ${particle.pulse ? 'animate-pulse' : 'animate-float'}`} style={{
        left: `${particle.x}%`,
        top: `${particle.y}%`,
        width: `${particle.size}px`,
        height: `${particle.size}px`,
        opacity: particle.opacity,
        animationDuration: `${particle.duration}s`,
        animationDelay: `${particle.delay}s`,
        boxShadow: '0 0 15px 5px rgba(59, 123, 253, 0.4)'
      }} data-id="element-168"></div>)}
      </div>
      {/* Animated strings/lines */}
      <div className="absolute inset-0 z-5 overflow-hidden" data-id="element-169">
        {/* Horizontal lines */}
        {[...Array(5)].map((_, i) => <div key={`h-line-${i}`} className="absolute h-px bg-gradient-to-r from-transparent via-blue-primary to-transparent animate-pulse" style={{
        top: `${20 + i * 15}%`,
        left: '0',
        width: '100%',
        opacity: 0.2,
        animationDuration: `${6 + i}s`
      }} data-id="element-170"></div>)}
        {/* Vertical lines */}
        {[...Array(5)].map((_, i) => <div key={`v-line-${i}`} className="absolute w-px bg-gradient-to-b from-transparent via-blue-light to-transparent animate-pulse" style={{
        left: `${20 + i * 15}%`,
        top: '0',
        height: '100%',
        opacity: 0.15,
        animationDuration: `${7 + i}s`
      }} data-id="element-171"></div>)}
        {/* Diagonal data streams */}
        {[...Array(8)].map((_, i) => <div key={`data-stream-${i}`} className="absolute bg-blue-primary/10 animate-dataStream" style={{
        height: '1px',
        width: `${Math.random() * 150 + 100}px`,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        transform: `rotate(${Math.random() * 360}deg)`,
        animationDuration: `${Math.random() * 8 + 4}s`,
        animationDelay: `${Math.random() * 2}s`
      }} data-id="element-172"></div>)}
      </div>
      {/* Digital circuit patterns */}
      <div className="absolute inset-0 z-5 pointer-events-none" data-id="element-173">
        {[...Array(4)].map((_, i) => <div key={`circuit-${i}`} className="absolute opacity-10" style={{
        width: `${Math.random() * 150 + 100}px`,
        height: `${Math.random() * 150 + 100}px`,
        left: `${Math.random() * 80}%`,
        top: `${Math.random() * 80}%`,
        background: `url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMTBMMzAgMTBMMzAgMzBMNTAgMzBMNTAgNTBMNzAgNTBMNzAgNzBMOTAgNzAiIHN0cm9rZT0iIzNCN0JGRCIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIi8+PC9zdmc+')`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        transform: `rotate(${Math.random() * 360}deg)`
      }} data-id="element-174"></div>)}
      </div>
      {/* Animated grid overlay */}
      <div className="absolute inset-0 z-5" data-id="element-175">
        <div className="w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAwIDEwIEwgNDAgMTAgTSAxMCAwIEwgMTAgNDAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSg1OSwgMTIzLCAyNTMsIDAuMSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIgLz48L3N2Zz4=')] opacity-30 animate-pulse" style={{
        animationDuration: '15s'
      }} data-id="element-176"></div>
      </div>
      {/* Glowing orbs */}
      <div className="absolute inset-0 z-5 overflow-hidden" data-id="element-177">
        {[...Array(3)].map((_, i) => <div key={`orb-${i}`} className="absolute rounded-full bg-blue-primary/10 blur-xl animate-orb" style={{
        width: `${Math.random() * 200 + 100}px`,
        height: `${Math.random() * 200 + 100}px`,
        left: `${Math.random() * 80}%`,
        top: `${Math.random() * 80}%`,
        animationDuration: `${Math.random() * 30 + 20}s`,
        animationDelay: `${Math.random() * 5}s`
      }} data-id="element-178"></div>)}
      </div>
      {/* Pattern overlay */}
      <div className="absolute inset-0 z-10 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/noise-pattern-with-subtle-cross-lines.png')]" data-id="element-179"></div>
      {/* Content */}
      <div className="container mx-auto px-4 h-full flex flex-col justify-center items-center relative z-20" data-id="element-180">
        <div className={`text-center transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} data-id="element-181">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 tracking-tight" data-id="element-182">
            <span className="block mt-2 bg-gradient-to-r from-white via-blue-light to-blue-primary bg-clip-text text-transparent animate-gradientFlow relative" data-id="element-183">
              CALLVANA
              <span className="absolute -inset-1 bg-blue-primary/20 blur-xl animate-pulse opacity-70 rounded-full" style={{
              animationDuration: '3s'
            }} data-id="element-184"></span>
            </span>
            <span className="block mt-4 text-2xl md:text-3xl font-medium animate-fadeIn" style={{
            animationDelay: '0.6s',
            animationDuration: '1s'
          }} data-id="element-185">
              Where Every Ring Means Business
            </span>
          </h1>
          <p className="max-w-2xl mx-auto text-gray-300 text-lg md:text-xl mb-8 animate-fadeIn" style={{
          animationDelay: '0.9s',
          animationDuration: '1s'
        }} data-id="element-186">
            Our elite team of experienced virtual assistants will help you reach your
            sales targets and deliver qualified leads for exceptional results.
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-8 animate-fadeIn" style={{
          animationDelay: '1.2s',
          animationDuration: '1s'
        }} data-id="element-187">
            <a href="#contact" className="px-8 py-3 bg-gradient-to-r from-blue-primary to-blue-light text-white font-bold rounded-md hover:from-blue-dark hover:to-blue-primary transition-all transform hover:scale-105 uppercase tracking-wide text-sm md:text-base relative overflow-hidden group" data-id="element-188">
              <span className="relative z-10" data-id="element-189">Boost Your Sales Team</span>
              <span className="absolute top-0 left-0 w-full h-full bg-white/20 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-300" data-id="element-190"></span>
            </a>
            <a href="#services" className="px-8 py-3 border border-blue-primary text-blue-light font-bold rounded-md hover:bg-blue-primary/10 transition-all transform hover:scale-105 uppercase tracking-wide text-sm md:text-base relative overflow-hidden group" data-id="element-191">
              <span className="relative z-10" data-id="element-192">Explore Our Services</span>
              <span className="absolute top-0 left-0 w-0 h-full bg-blue-primary/20 transition-all duration-300 group-hover:w-full" data-id="element-193"></span>
            </a>
          </div>
        </div>
      </div>
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce" data-id="element-194">
        <ChevronDown size={32} className="text-blue-light" data-id="element-195" />
      </div>
      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-black to-transparent z-10" data-id="element-196"></div>
    </section>;
};